import { CustomRequestOptions } from '@/interceptors/request'
import { loginRoute } from '@/interceptors/route'
import { useUserStore } from '@/store'
import { showModal } from '.'

export const http = <T = any>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<IResData<T>>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      async success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          if (res.header['content-type'].includes('application/json')) {
            // 2.1 提取核心数据 res.data
            const data = res.data as IResData<T>
            if (data.code === 1) {
              resolve(data as IResData<T>)
            } else if (data.code === 401) {
              const userStore = useUserStore()
              userStore.logout()
              !options.hideErrorToast &&
                (await showModal(data.msg || '请求错误', {
                  showCancel: false,
                }))
              uni.reLaunch({
                url: loginRoute,
              })

              reject(res)
            } else {
              !options.hideErrorToast &&
                (await showModal(data.msg || '请求错误', {
                  showCancel: false,
                }))
              reject(res)
            }
          } else {
            resolve(res.data as any)
          }
        } else if (res.statusCode === 401) {
          const userStore = useUserStore()
          userStore.logout()
          !options.hideErrorToast &&
            (await showModal(res.data.msg || '请求错误', {
              showCancel: false,
            }))
          uni.reLaunch({
            url: loginRoute,
          })

          reject(res)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            (await showModal((res.data as IResData<T>).msg || '请求错误', {
              showCancel: false,
            }))
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: '网络错误，换个网络试试',
        })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @returns
 */
export const httpGet = <T>(url: string, query?: Record<string, any>) => {
  return http<T>({
    url,
    query,
    method: 'GET',
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpPost = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
) => {
  return http<T>({
    url,
    query,
    data,
    method: 'POST',
  })
}

http.get = httpGet
http.post = httpPost
